import { GenerarConsultasParametrosEjecucionDTO } from "./GenerarConsultasParametrosEjecucionDTO";

export class GenerarConsultasEjecucionDTO {
    id: number;
    nombreConsulta: string;
    listaParametros: GenerarConsultasParametrosEjecucionDTO[];
}